import 'regenerator-runtime/runtime';
import axios from 'axios';
import { getAccessToken } from './Auth.util';
import { EPE_CORRELATION_ID, MICRO_FRONTEND_STARGATE_KEY } from '../constants/index';

// Helper method for basic GET HTTP calls
export const getAPI = async (
    url,
    parameters = undefined,
    token = undefined,
    cookie = undefined,
    requestId = null
) => {
    try {
        const headers = token
            ? {
                  Authorization: 'Bearer ' + token,
              }
            : cookie
            ? {
                  Cookie: cookie,
              }
            : {};
        if (requestId) {
            headers[EPE_CORRELATION_ID] = requestId;
        }

        const response = await axios.get(url, {
            headers: headers,
            params: parameters,
        });

        return response;
    } catch (error) {
        return error;
    }
};

// Helper method for basic POST HTTP calls
export const postAPI = async (
    url,
    payload,
    cpttCorrelationID = null,
    sourcePortal = null,
    accessToken = null
) => {
    const token = accessToken || (await getAccessToken('Stargate_token'));
    try {
        const response = await axios.post(url, JSON.stringify(payload), {
            headers:
                cpttCorrelationID != 'undefined' && cpttCorrelationID != null
                    ? {
                          'Content-Type': 'application/json',
                          Authorization: 'Bearer ' + token,
                          ...(cpttCorrelationID && {
                              'x-rally-correlationid': cpttCorrelationID,
                          }),
                          ...(sourcePortal && {
                              'X-EPE-SourcePortal': sourcePortal,
                          }),
                      }
                    : {
                          'Content-Type': 'application/json',
                          Authorization: 'Bearer ' + token,
                          ...(sourcePortal && {
                              'X-EPE-SourcePortal': sourcePortal,
                          }),
                      },
        });

        return response;
    } catch (error) {
        return error;
    }
};

export const validityChecker = (val) => {
    if (val == undefined) {
        return '';
    } else {
        return val;
    }
};

export const postLogsToServer = async (logs = []) => {
    const token = await getAccessToken(MICRO_FRONTEND_STARGATE_KEY);

    try {
        const url = process.env.LOGS_SERVICE_URL;
        const response = await axios.post(url, logs, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
        });
        return response;
    } catch (error) {
        return error;
    }
};
